import { ComponentRef } from '@angular/core';
import { IComponent } from './componentType';

export class FilterSectionItem {
  component!: ComponentRef<unknown>;
  components!: () => IComponent[];

}
